const local = {
  api: {
    URL: 'http://localhost:6969'
  },
  stage: 'local'
}

const beta = {
  api: {
    URL: 'https://xcaikca1m3.execute-api.eu-west-2.amazonaws.com/prod'
  },
  stage: 'beta'
}

const prod = {
  api: {
    URL: 'https://4qq8b007ul.execute-api.eu-west-2.amazonaws.com/prod'
  },
  stage: 'prod'
}

let config
if (process.env.REACT_APP_STAGE === 'prod') {
  config = prod
} else if (process.env.REACT_APP_STAGE === 'beta') {
  config = beta
} else {
  config = local
}

export default {
  ...config,
  cognito: {
    region: 'eu-west-2',
    userPoolId: 'eu-west-2_rnHGJxUZZ',
    userPoolWebClientId: '4hjnt8rrb9dmi604c6pu2uvq62',
    identityPoolId: 'eu-west-2:e7046934-8c81-4c45-875c-4f0b39ab60a4'
  }
}
